import { filterAttrLabelData } from "src/common/attributes/makeAttrLabel/utils/filterAttrLabelData";
import { getAllLabelDataAttributes } from "src/common/attributes/makeAttrLabel/utils/getAllLabelDataAttributes";
import { ZAttrLabelsData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { AttrTypeName } from "src/types/AttrType";

export const filterObjectRefLabelTreeData = (
  labelsData: ZAttrLabelsData | undefined,
  typesMap: Record<number, string>,
) => {
  const filtered = filterAttrLabelData(
    labelsData?.labels || [],
    getAllLabelDataAttributes(labelsData?.attributes),
    typesMap,
    [AttrTypeName.image, AttrTypeName.file],
  );
  return { ...labelsData, labels: filtered };
};
